import * as yup from "yup";

import {
  ImportFieldMapping,
  PendingCustomerJSON
} from "src/core/shared/api/importSetting.api";

export type ImportJSON = PendingCustomerJSON;

/**
 * Takes header mapping, if validation exists, returns yep schema based on validation options
 *
 * @param {ValidationField} headerMapping - The field to create yup validation schema for.
 */
export const validateHeaderMappingField = (headerMapping: ImportFieldMapping<ImportJSON>) => {
  if (!headerMapping.validation) {
    throw new Error("Validation is required when validating generating yup schema from header mapping");
  }

  let schema: yup.StringSchema | yup.NumberSchema = yup.string();

  // Account for type
  switch (headerMapping.type) {
    case "email":{
      schema = schema.email();
      break;
    }

    case "phone": {
      schema = schema.matches(/^(|\+\d{2})(\d{10,11})$/);
      break;
    }

    case "number": {
      schema = yup.number();
      break;
    }

    default:
      schema;
      break;
  }

  // Account for validation
  if (headerMapping.validation) {
    if (headerMapping.validation.min) {
      schema = schema.min(headerMapping.validation.min);
    }

    if (headerMapping.validation.max) {
      schema = schema.max(headerMapping.validation.max);
    }

    if (headerMapping.validation.required) {
      schema = schema.required();
    }

    if (headerMapping.validation.regex && schema instanceof yup.string) {
      schema = schema.matches(new RegExp(headerMapping.validation.regex), headerMapping.validation.regexMessage);
    }
  }

  return schema;
};
